export default {
  A4: 0,
  A3: 1,
};
